<template>
  <div class="card">
    <img :src="imageSrc"/>
    <div class="card-overlay">
      <p class="project-name">{{ projectName }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageCard',
  props: {
    imageSrc: String,
    projectName: String
  }
};
</script>

<style scoped>
.card {
  position: relative;
  display: inline-block;
  margin: 0;
  padding: 0;
  background-color: #30008a;
}

.card img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

.card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
}

.card:hover .card-overlay {
  opacity: 1;
}

.project-name {
  color: white;
  font-size: 1.25rem;
  text-align: center;
  padding: 1rem;
}

@media only screen and (max-width: 1380px) {

.project-name {
  font-size: smaller;
}

}

@media only screen and (max-width: 600px) {

.project-name {
  font-size: x-small;
}

}


</style>
